export default __webpack_public_path__ + "static/media/HedgeCutting.4589c321.jpg";